import { render, staticRenderFns } from "./ordersItem.vue?vue&type=template&id=66d7a1f4&scoped=true"
import script from "./ordersItem.vue?vue&type=script&lang=js"
export * from "./ordersItem.vue?vue&type=script&lang=js"
import style0 from "./ordersItem.vue?vue&type=style&index=0&id=66d7a1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7a1f4",
  null
  
)

export default component.exports